export const getObjectItem = (data = {}, selector = "") => {
  const type = typeof selector;
  if (type === "string") return data?.[selector];
  if (type === "function") return selector(data);
  return null;
};

export const formatArray = (data) => (Array.isArray(data) ? data : []);

export const convertId2String = (data = []) =>
  (data ?? []).map((item = {}) => ({
    ...(item ?? {}),
    id: String(item?.id ?? ""),
  }));

export const loopSelf = (
  data = [],
  onEach = () => {},
  onFinish = () => {},
  current = 0
) => {
  if (current < data?.length) {
    onEach(
      // next
      () => {
        loopSelf(data, onEach, onFinish, current + 1);
      },
      // current item
      data?.[current],
      // current index
      current,
      // self
      data
    );
  } else {
    onFinish();
  }
};

export const modifyArray = (data = [], index = 0, modifyItem = {}) => {
  const newArray = [
    ...data.slice(0, index),
    modifyItem,
    ...data.slice(index + 1),
  ];
  return newArray;
};

export const removeItemArray = (data = [], index = 0) => {
  const newArray = [...data.slice(0, index), ...data.slice(index + 1)];
  return newArray;
};

export const addItemArray = (data = [], newItem = {}) => {
  const newArray = [...data, newItem];
  return newArray;
};

export const groupBy = (array, key) => {
  // Return the end result
  return array
    ?.filter((item) => item)
    .reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
};
